import { all, fork } from "redux-saga/effects";

import ProfileSaga from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";
import ecommerceSaga from "./e-commerce/saga";
import invoiceSaga from "./invoices/saga";
import dashboardSaga from "./dashboard/saga";
import roleSaga from "./Role/saga"

export default function* rootSaga() {
  yield all([
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(ecommerceSaga),
    fork(invoiceSaga),
    fork(dashboardSaga),
    fork(roleSaga),
  ]);
}
